<template>
  <ul v-if="alerts.length" class="alerts">
    <li v-for="alert in alerts" :key="alert.code + alert.message" class="alert" :class="alert.level">
      <span class="fas" :class="alert.level === 'critical' ? 'fa-circle-exclamation' : 'fa-triangle-exclamation'"></span>
      <span class="alert-text">{{ alert.message }}</span>
    </li>
  </ul>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleExclamation, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
library.add(faCircleExclamation, faTriangleExclamation);

/**
 * Les alertes d'un container (ou de la machine hôte) : avertissements en orange, alertes critiques en rouge.
 */
export default {
  name: 'ContainerAlerts',
  props: {
    alerts: {type: Array, required: true},
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.alerts
  display flex
  flex-direction column
  gap 6px
  margin 0
  padding 0
  list-style none

.alert
  display flex
  align-items flex-start
  gap 8px
  padding 8px 12px
  font-size 13px
  border 1px solid
  border-radius 10px

  &.warning
    color #8a5a00
    background #fff6e0
    border-color #f0d9a3

  &.critical
    color CTRL_ERROR
    background CTRL_ERROR_BG
    border-color #f3c6cd

.alert-text
  min-width 0
  overflow-wrap anywhere
</style>
